import PublishIcon from '@mui/icons-material/Publish';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { palette } from "../assets/theme/theme";
import { ButtonRow } from '../components/ButtonRow';
import HorizontalRule from '../components/HorizontalRule/HorizontalRule';


type FormButtonsInput = {
    isNewEntity: boolean,
    submitData: Function,
    onCancel: Function | null,
    patchData: Function,
    isCopy: boolean,
    setIsOpen: Function,
    setEditable: Function
}



export default function FormButtons({ isNewEntity, submitData, onCancel, patchData, isCopy, setIsOpen, setEditable }: FormButtonsInput) {

    const getButtons = () => {
        const arr = [];

        if (isNewEntity) {
            arr.push({ text: "Submeter", color: palette.green, onClick: submitData, icon: PublishIcon, className: 'bg-lime-600 hover:border-lime-600 hover:text-lime-600' });
            arr.push({ text: "Cancelar", color: palette.red, onClick: () => onCancel ? onCancel() : isCopy ? setIsOpen(false) : setEditable(false), icon: CancelIcon });
        } else {
            arr.push({ text: "Guardar", color: palette.green, onClick: patchData, icon: SaveIcon , className: 'bg-lime-600 hover:border-lime-600 hover:text-lime-600'});
            arr.push({ text: "Cancelar", color: palette.red, onClick: () => isCopy ? setIsOpen(false) : setEditable(false), icon: CancelIcon });
        }


        return arr;
    }



    return (<div className='mt-2'>
            <HorizontalRule/>
            <ButtonRow
                buttons={getButtons()}
                className={"mt-6"}
            />
        </div>
    )
}